import { searchSectionById, searchSectionByType } from '../config/search.js';

const normalize = value => String(value || '')
  .normalize('NFKD')
  .replace(/[\u064B-\u065F\u0670\u0640]/g,'')
  .replace(/[إأآٱ]/g,'ا')
  .replace(/ى/g,'ي')
  .replace(/ة/g,'ه')
  .toLocaleLowerCase('ar')
  .trim();

const searchableText = item => normalize([
  item.title,
  item.shortDescription,
  item.description,
  item.category?.label,
  ...(item.tags || [])
].join(' '));

const scoreResult = (item, needle) => {
  if (!needle) return 0;
  const title = normalize(item.title);
  const tags = normalize((item.tags || []).join(' '));
  if (title === needle) return 100;
  if (title.startsWith(needle)) return 70;
  if (title.includes(needle)) return 50;
  if (tags.includes(needle)) return 30;
  return 10;
};

const toSearchResult = item => ({
  id:item.id,
  type:item.type,
  section:searchSectionByType[item.type]?.id || '',
  typeLabel:item.typeLabel,
  title:item.title,
  excerpt:item.shortDescription || item.description,
  source:item.category?.label || item.typeLabel,
  image:item.image || '',
  path:item.path
});

export async function searchResources({ query='', section='', page=1, pageSize=8, signal } = {}) {
  if (signal?.aborted) throw new DOMException('Aborted','AbortError');

  const needle = normalize(query);
  const selectedType = searchSectionById[section]?.type || '';
  const safePage = Math.max(1,Number.parseInt(page,10) || 1);
  const safePageSize = Math.max(1,Math.min(24,Number.parseInt(pageSize,10) || 8));

  const {resources}=await import('../data/resources.js');
  if (signal?.aborted) throw new DOMException('Aborted','AbortError');

  const matches = resources
    .filter(item => (!selectedType || item.type === selectedType) && (!needle || searchableText(item).includes(needle)))
    .map(item => ({ item, score:scoreResult(item,needle) }))
    .sort((a,b) => b.score - a.score || a.item.title.localeCompare(b.item.title,'ar'))
    .map(({ item }) => toSearchResult(item));

  const total = matches.length;
  const pages = Math.max(1,Math.ceil(total / safePageSize));
  const currentPage = Math.min(safePage,pages);
  const start = (currentPage - 1) * safePageSize;

  return {
    items:matches.slice(start,start + safePageSize),
    total,
    page:currentPage,
    pages,
    query:String(query || '').trim(),
    section:selectedType ? section : ''
  };
}
